import React from 'react'
import GAAlbumsContainer from '../../modules/GAAlbums/containers/GAAlbumsContainer/GAAlbumsContainer'

const GAAlbums = () => {
  return (
    <GAAlbumsContainer />
  )
}

export default GAAlbums